import sealUrl from "@/assets/liamuiga/liamuiga-seal.svg";
import wordmarkUrl from "@/assets/liamuiga/liamuiga-wordmark.svg";
import { cn } from "@/lib/utils";

interface SealProps {
  className?: string;
  tone?: "gold" | "light" | "dark";
}

const toneClass = {
  gold: "text-[hsl(38_65%_55%)]",
  light: "text-[hsl(40_35%_94%)]",
  dark: "text-[hsl(150_35%_10%)]",
} as const;

export const CollectionSeal = ({ className, tone = "gold" }: SealProps) => (
  <img
    src={sealUrl}
    alt="The Living Legacy of Liamuiga seal"
    className={cn(toneClass[tone], className)}
  />
);

export const CollectionWordmark = ({ className, tone = "gold" }: SealProps) => (
  <img
    src={wordmarkUrl}
    alt="The Living Legacy of Liamuiga"
    className={cn(toneClass[tone], className)}
  />
);
